import React, { useContext, useEffect, useState } from 'react'
import { Navigate, useLocation } from 'react-router-dom'

import { AuthContext } from '../../contexts/auth-context'

const ProtectedRoute = ({ children, allowedRoles = [], allowedPlans = [] }) => {
  const { auth, loading, checkAuthUser } = useContext(AuthContext)

  const location = useLocation()
  const [initialLoadComplete, setInitialLoadComplete] = useState(false)
  const path = location.pathname
  const plan = auth?.user?.subscription?.planTier || 'basic'

  // Extract auth data
  const { authenticate, user } = auth

  // Re-check auth on every page navigation
  useEffect(() => {
    checkAuthUser()
  }, [location.pathname]) //  will fire whenever user changes route

  // Allow time for auth to load before making redirect decisions
  useEffect(() => {
    if (!loading) {
      setInitialLoadComplete(true)
    }
  }, [loading])

  // Show loading state while auth is initializing
  if (loading || !initialLoadComplete) {
    return <div className="text-center mt-10">Loading...</div>
  }

  // Not authenticated case
  if (!authenticate) {
    // Store the current URL to return to after authentication
    sessionStorage.setItem('returnUrl', location.pathname)
    return <Navigate to="/" replace />
  }

  // Role-based access control
  if (allowedRoles.length > 0 && !allowedRoles.includes(user?.role)) {
    return <Navigate to="/unauthorized" replace />
  }

  if (allowedPlans.length > 0 && !allowedPlans.includes(plan?.toLowerCase())) {
    return <Navigate to="/unauthorized" replace />
  }

  // If business tries inside routes without a subscription, redirect to purchase plan screen except profile page content // CHECK
  if (
    user &&
    user?.role === 'Business' &&
    !path.includes('profile') &&
    (!user?.subscription ||
      user?.subscription?.status !== 'active' ||
      user?.subscription?.cancelAtPeriodEnd)
  ) {
    return <Navigate to="/purchase-plan" replace />
  }

  // Auto-redirect logic based on role
  if (user?.role === 'user' && !path.startsWith('/user')) {
    return <Navigate to="/user" replace />
  }

  if (user?.role === 'Business' && !path.startsWith('/business')) {
    return <Navigate to="/business" replace />
  }

  return children
}

export default ProtectedRoute
